/**
 * Extrai a mensagem útil de um erro da API.
 *
 * O backend responde em dois formatos, e ler só um deles faz a causa real virar
 * `undefined` — o usuário leva um texto genérico e a explicação que o servidor
 * mandou se perde:
 *
 * - `{ error }` — errorHandler global (ApiError). Ex.: "O billing contábil
 *   app=docugen está disponível somente para o DocuGen".
 * - `{ message }` — controllers que montam a resposta na mão (financeiro).
 * - `{ error: 'Validation error', details: [{ message }] }` — express-validator,
 *   onde só `details` diz qual campo reprovou. Por isso `details` vem primeiro.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const e = err as {
    response?: {
      data?: {
        error?: unknown;
        message?: unknown;
        details?: Array<{ message?: unknown }>;
      };
    };
    message?: unknown;
  };
  const data = e?.response?.data;
  const candidates = [data?.details?.[0]?.message, data?.error, data?.message, e?.message];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate;
    }
  }
  return fallback;
}
